module.exports = __webpack_public_path__ + "static/media/icn-share-24px.1a3673a8.svg";